import { Globe, CreditCard, Package } from "lucide-react";
import { cn } from "@/lib/utils";

const HowToBuy = () => {
  const steps = [
    {
      number: 1,
      title: "Crear tu Orden",
      icon: Globe,
      items: [
        "En la página web",
        "Pedir cotización por WhatsApp",
      ],
    },
    {
      number: 2,
      title: "Pagar tu Orden",
      icon: CreditCard,
      items: [
        "Tarjeta de Débito / Crédito",
        "Transferencia / SINPE",
        "Efectivo contra entrega",
      ],
    },
    {
      number: 3,
      title: "Recibir tus Productos",
      icon: Package,
      items: [
        "Envío a domicilio",
        "Retiro en sucursal",
        "Delivery express",
      ],
    },
  ];

  return (
    <section className="py-12 bg-muted">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">
          ¡Hacer Tu Pedido es Muy Fácil!
        </h2>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {steps.map((step) => (
            <div 
              key={step.number}
              className={cn(
                "bg-card rounded-lg border border-border p-6",
                "hover:shadow-card transition-shadow duration-300"
              )}
            >
              {/* Header */}
              <div className="flex items-center gap-3 mb-4">
                <span className="step-number">{step.number}</span>
                <h3 className="text-lg font-bold text-cta">{step.title}</h3>
              </div>

              {/* Items */}
              <ul className="space-y-3">
                {step.items.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-muted-foreground">
                    <step.icon className="h-4 w-4 text-primary flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-muted-foreground mt-6 max-w-2xl mx-auto">
          * Consulta con nuestro equipo de ventas para conocer las opciones de pago y envío disponibles en tu zona.
        </p>
      </div>
    </section>
  );
};

export default HowToBuy;
